/*! Argon Dashboard React - Creative Tim */

import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import { AuthProvider, useAuthContext } from "./contexts/AuthContext";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

function App() {
  const { login, logout, user, loading } = useAuthContext();
  const [showLoginButton, setShowLoginButton] = useState(true);

  const handleLogin = () => {
    login("valid-token");
    setShowLoginButton(false);
  };

  const handleLogout = () => {
    logout();
    setShowLoginButton(true);
  };

  useEffect(() => {
    if (user == undefined || user == null) {
    } else {
      setShowLoginButton(false);
    }
  }, [user]);

  return (
    <>
      {loading ? (
        <p>Cargando...</p>
      ) : user ? (
        <BrowserRouter>
          <Routes>
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="*" element={<Navigate to="/admin/index" replace />} />
          </Routes>
        </BrowserRouter>
      ) : showLoginButton ? (
        <BrowserRouter>
          <Routes>
            <Route path="/auth/*" element={<AuthLayout />} />
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </Routes>
        </BrowserRouter>
      ) : (
        <p>No estás autenticado.</p>
      )}
    </>
  );
}

root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
